module.exports = __webpack_public_path__ + "img/banner-02-rivoneed.63a9c425.webp";